/** Страница подтверждения e-mail: передаёт серверу адрес и код из письма. */
import { useForm } from "@tanstack/react-form";
import { useState } from "react";
import { Link } from "react-router-dom";
import { z } from "zod";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const confirmEmailSchema = z.object({
	code: z.string().min(1, "Введите код"),
	email: z
		.string()
		.min(1, "Введите электронную почту")
		.email("Введите корректную электронную почту"),
});

export const ConfirmEmailPage = () => {
	const [isSubmitted, setIsSubmitted] = useState(false);
	const confirmEmailApi = apiHooks.auth.useConfirmEmail();
	const form = useForm({
		defaultValues: { code: "", email: "" },
		validators: { onChange: confirmEmailSchema },
		onSubmit: async ({ value }) => {
			const response = await confirmEmailApi.execute(value);
			if (response.error !== null) return;
			setIsSubmitted(true);
		},
	});

	return (
		<div className="flex flex-1 items-center justify-center overflow-y-auto px-5 py-10">
			<form className="w-full max-w-sm" action={() => form.handleSubmit()}>
				<UIKit.Text className="mb-2 font-medium text-accent">GRID PLANNER</UIKit.Text>
				<UIKit.Text size="xl">Подтвердить почту</UIKit.Text>
				<UIKit.Text className="mt-2 text-ink">Введите адрес и код из письма.</UIKit.Text>
				<div className="mt-7 space-y-4">
					<UIKit.FormField form={form} name="email">
						{(field) => (
							<UIKit.TextInput
								label="Электронная почта"
								type="email"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="email"
							/>
						)}
					</UIKit.FormField>
					<UIKit.FormField form={form} name="code">
						{(field) => (
							<UIKit.TextInput
								label="Код"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="one-time-code"
							/>
						)}
					</UIKit.FormField>
				</div>
				{isSubmitted && (
					<UIKit.Text className="mt-4 text-green-700">Почта подтверждена.</UIKit.Text>
				)}
				<UIKit.Button
					className="mt-6 w-full border-accent bg-accent py-3 text-sm font-medium text-overlay-ink hover:border-accent-hover hover:bg-accent-hover"
					type="submit"
					disabled={confirmEmailApi.isPending}
				>
					{confirmEmailApi.isPending ? "Подтверждаем..." : "Подтвердить"}
				</UIKit.Button>
				<UIKit.Text className="mt-5 text-center text-ink">
					<Link className="font-medium text-accent hover:underline" to={routerPaths.login}>
						Вернуться ко входу
					</Link>
				</UIKit.Text>
			</form>
		</div>
	);
};
